import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["className", "tags", "children", "maxShowLength", "showLength", "maxLength", "onToggleExpand", "onCloseAll", "onClick", "onMouseDown", "closeWhenTagClose"],
    _excluded2 = ["onClose"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import classNames from '@jd/jmtd-tools/es/classnames';
import { css, px } from '@jd/jmtd-tools/es/css';
import { createElement, setClass } from '@jd/jmtd-tools/es/element';
import refresh from '@jd/jmtd-tools/es/refresh';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { createPortal } from 'react-dom';
import ResizeObserver from 'resize-observer-polyfill';
import BaseInput from '../BaseInput';
import Button from '../Button';
import ConfigConsumer from '../ConfigConsumer';
import { getLocale } from '../locale';
import Tag from '../Tag';
import { CloseOther } from '../tools/closeOther'; // 元素能否触发事件（focus、open）

export function canElementTriggerEvent(el) {
  return !el.classList.contains('jmti-close') && !el.classList.contains('jmtd-multiple-base-input-number-tag');
}

var _CloseOther = CloseOther({
  isElementMatch: function isElementMatch(element, _ref) {
    var target = _ref.target;
    return element === target;
  }
}),
    closeOther = _CloseOther.closeOther,
    addNode = _CloseOther.addNode,
    removeNode = _CloseOther.removeNode;

var MultipleBaseInput = /*#__PURE__*/function (_PureComponent) {
  _inherits(MultipleBaseInput, _PureComponent);

  var _super = _createSuper(MultipleBaseInput);

  function MultipleBaseInput(props) {
    var _this;

    _classCallCheck(this, MultipleBaseInput);

    _this = _super.call(this, props);
    _this.state = {
      open: false
    };
    _this.portal = createElement('div.jmtd-multiple-base-input-portal', document.body);
    return _this;
  }

  _createClass(MultipleBaseInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var tagWrapper = this.tagWrapper,
          portal = this.portal;
      var inputParent = tagWrapper.parentElement.parentElement.parentElement;
      var portalInputParent = portal.firstElementChild;
      this.refreshHandle = refresh(function () {
        var open = _this2.state.open;

        if (open) {
          var _inputParent$getBound = inputParent.getBoundingClientRect(),
              x = _inputParent$getBound.x,
              y = _inputParent$getBound.y;

          css(portal, {
            left: px(x),
            top: px(y)
          });
        }
      }); // 计算展开额外高度

      var resizeObserver = this.resizeObserver = new ResizeObserver(function () {
        var _portalInputParent$ch = _slicedToArray(portalInputParent.children, 2),
            first = _portalInputParent$ch[0],
            second = _portalInputParent$ch[1];

        _this2.extraHeight = first.offsetHeight + second.offsetHeight + 2 - inputParent.offsetHeight;

        _this2.componentDidUpdate();
      });
      resizeObserver.observe(portalInputParent.firstElementChild);
      addNode(this.node = {
        target: portalInputParent,
        close: function close() {
          _this2.setState({
            open: false
          });
        }
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var open = this.state.open,
          extraHeight = this.extraHeight,
          portal = this.portal,
          tagWrapper = this.tagWrapper,
          baseHeight = this.baseHeight;
      var inputParent = tagWrapper.parentElement.parentElement.parentElement;
      var portalInputParent = portal.firstElementChild;
      this.baseHeight = inputParent.offsetHeight;
      css(portalInputParent, 'height', px(this.baseHeight));
      setClass(portal, 'jmtd-multiple-base-input-portal-open', open);
      css(portal.firstElementChild, 'height', px(open ? baseHeight + extraHeight : baseHeight));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeChild(this.portal);
      this.refreshHandle.remove();
      this.resizeObserver.disconnect();
      removeNode(this.node);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          className = _this$props.className,
          tags = _this$props.tags,
          children = _this$props.children,
          maxShowLength = _this$props.maxShowLength,
          showLength = _this$props.showLength,
          maxLength = _this$props.maxLength,
          onToggleExpand = _this$props.onToggleExpand,
          onCloseAll = _this$props.onCloseAll,
          onClick = _this$props.onClick,
          onMouseDown = _this$props.onMouseDown,
          closeWhenTagClose = _this$props.closeWhenTagClose,
          other = _objectWithoutProperties(_this$props, _excluded),
          open = this.state.open;

      var tagsLength = tags.length;

      var element = function element(_ref2) {
        var ref = _ref2.ref,
            renderChildren = _ref2.renderChildren,
            innerClassName = _ref2.className,
            bottom = _ref2.bottom,
            showTags = _ref2.tags;
        return /*#__PURE__*/React.createElement(BaseInput, _extends({
          allowClear: false,
          className: classNames('jmtd-multiple-base-input', className, innerClassName),
          right: showLength && tagsLength > 0 && /*#__PURE__*/React.createElement(Tag, {
            size: "small",
            className: classNames('jmtd-multiple-base-input-number-tag', {
              'jmtd-multiple-base-input-has-max-length': !!maxLength,
              'jmtd-multiple-base-input-over-length': maxLength && tagsLength > maxLength
            }),
            onClick: function onClick() {
              closeOther();
              onToggleExpand(!open);

              _this3.setState({
                open: !open
              });
            }
          }, /*#__PURE__*/React.createElement("span", {
            className: "jmtd-multiple-base-input-number-length"
          }, tagsLength), maxLength && /*#__PURE__*/React.createElement("span", {
            className: "jmtd-multiple-base-input-number-max-length"
          }, "/", maxLength)),
          bottom: bottom,
          onClick: bottom ? function () {} : onClick,
          onMouseDown: bottom ? function () {} : onMouseDown
        }, other), /*#__PURE__*/React.createElement("div", {
          className: "jmtd-multiple-base-input-tag-wrapper",
          ref: ref
        }, showTags.map(function (_ref3, index) {
          var _onClose = _ref3.onClose,
              otherTagProps = _objectWithoutProperties(_ref3, _excluded2);

          return /*#__PURE__*/React.createElement(Tag, _extends({
            size: "small",
            key: index,
            onClose: function onClose() {
              if (_onClose() || closeWhenTagClose) {
                _this3.setState({
                  open: false
                });
              }
            }
          }, otherTagProps));
        }), renderChildren && children));
      };

      return /*#__PURE__*/React.createElement(React.Fragment, null, element({
        ref: function ref(el) {
          _this3.tagWrapper = el;
        },
        tags: maxShowLength ? tags.slice(0, maxShowLength) : tags,
        // 根据maxShowLength进行截取
        renderChildren: true
      }), /*#__PURE__*/createPortal(element({
        tags: tags,
        ref: function ref(el) {
          _this3.portalTagWrapper = el;
        },
        className: 'jmtd-base-input-in-portal',
        bottom: /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref4) {
          var locale = _ref4.locale;
          return /*#__PURE__*/React.createElement(Button, {
            block: true,
            link: true,
            semantic: "primary",
            size: "middle",
            className: "jmtd-multiple-base-input-clear-all-button",
            onClick: function onClick() {
              if (onCloseAll() || closeWhenTagClose) {
                _this3.setState({
                  open: false
                });
              }
            }
          }, getLocale(locale).common.clearAll);
        })
      }), this.portal));
    }
  }]);

  return MultipleBaseInput;
}(PureComponent);

export { MultipleBaseInput as default };
MultipleBaseInput.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  focused: PropTypes.bool,
  placeholder: PropTypes.node,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  empty: PropTypes.bool,
  size: PropTypes.oneOf(['mini', 'small', 'middle', 'large']),
  onClear: PropTypes.func,
  tags: PropTypes.array,
  showLength: PropTypes.bool,
  maxLength: PropTypes.number,
  onCloseAll: PropTypes.func,
  onToggleExpand: PropTypes.func,
  maxShowLength: PropTypes.number,
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  closeWhenTagClose: PropTypes.bool
};
MultipleBaseInput.defaultProps = {
  children: null,
  className: '',
  focused: false,
  placeholder: null,
  width: null,
  startIcon: null,
  endIcon: null,
  empty: false,
  size: null,
  onClear: function onClear() {},
  tags: [],
  showLength: false,
  maxLength: null,
  onCloseAll: function onCloseAll() {},
  onToggleExpand: function onToggleExpand() {},
  maxShowLength: null,
  onClick: function onClick() {},
  onMouseDown: function onMouseDown() {},
  closeWhenTagClose: false
};